import { A3_BADGE_PATH, A3Badge } from '@frontend/data-access';
import getConfig from 'next/config';
import Image from 'next/image';

export function A3BadgeImage({
  className,
  badge,
}: {
  className?: string;
  badge: A3Badge;
}) {
  const { publicRuntimeConfig } = getConfig();

  const getBadge = () => {
    switch (badge.name) {
      case 'Novice':
        return A3_BADGE_PATH?.NOVICE;
      case 'Apprentice':
        return A3_BADGE_PATH?.APPRENTICE;
      case 'Pro':
        return A3_BADGE_PATH?.PRO;
      case 'Master':
        return A3_BADGE_PATH?.MASTER;
      default:
        return '';
    }
  };

  return (
    <Image
      src={`${publicRuntimeConfig.staticFolder}${getBadge()}`}
      alt={badge?.name}
      width={64}
      height={73}
      className={className + ' min-w-16 select-none'}
    />
  );
}
